import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {PRICES_HUB_ANALYTICS_LOCATION, PRICES_HUB_OFFERS_LIST_NAME} from "./prices_hub_analytics";

interface ITrackPricesHubOffersViewItemListParams {
    offers: IOfferListOffer[];
    itemListId?: string;
}

export const trackPricesHubOffersViewItemList = (params: ITrackPricesHubOffersViewItemListParams) => {
    trackAmplitudeOfferViewItemList({
        offers: params.offers,
        itemListId: params.itemListId,
        itemListName: PRICES_HUB_OFFERS_LIST_NAME,
        location: PRICES_HUB_ANALYTICS_LOCATION,
        isUspVariant: false,
        addressContext: {}
    });
};
import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {PRICES_HUB_ANALYTICS_LOCATION, PRICES_HUB_OFFERS_LIST_NAME} from "./prices_hub_analytics";

interface ITrackPricesHubOffersViewItemListParams {
    offers: IOfferListOffer[];
    itemListId?: string;
}

export const trackPricesHubOffersViewItemList = (params: ITrackPricesHubOffersViewItemListParams) => {
    trackAmplitudeOfferViewItemList({
        offers: params.offers,
        itemListId: params.itemListId,
        itemListName: PRICES_HUB_OFFERS_LIST_NAME,
        location: PRICES_HUB_ANALYTICS_LOCATION,
        isUspVariant: false,
        addressContext: {}
    });
};
